var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 104 104",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M98,66h-7.121c0-28.161-15.77-37.674-24.879-40.819v-5.848c0-3.313-2.686-6-6-6H42.666c-3.313,0-6,2.687-6,6v6.164 c-9.207,3.447-24,13.227-24,40.503H6c-3.314,0-6,2.687-6,6v12.667c0,3.312,2.686,6,6,6h17.334c3.313,0,6-2.688,6-6V72 c0-3.313-2.688-6-6-6h-6.668c0-23.872,11.848-32.916,20-36.319V32c0,3.313,2.688,6,6,6h6.668v28h-6.668c-3.313,0-6,2.687-6,6 v12.667c0,3.312,2.688,6,6,6H60c3.314,0,6-2.688,6-6V72c0-3.313-2.686-6-6-6h-6.666V38H60c3.314,0,6-2.687,6-6v-2.673 C74.148,32.438,86.879,41.255,86.879,66h-6.213c-3.312,0-6,2.687-6,6v12.667c0,3.312,2.688,6,6,6H98c3.314,0,6-2.688,6-6V72 C104,68.687,101.314,66,98,66z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflow);
export default __webpack_public_path__ + "static/media/workflow.53ec63ad8c82f23eafa4deb523b2b056.svg";
export { ForwardRef as ReactComponent };